// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { BellRing as RawBellRing } from "lucide-react";
export const BellRing = /* @__PURE__ */ createIcon(RawBellRing, "BellRing", 2);
